import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import period from '../../Assets/period.svg';
import './About.css'

function About2() {
  return (
    <Container fluid className="about-about-section" id="about">
      <Container>
        <Row>
          <Col md={6} className="about-about-description">
            <hr></hr>
            <div style={{display:'flex'}}>
          <h1 className="detail-header">
          EDUCATION 
            </h1>
            <img
                    src={period}
                    alt="period"
                    style={{marginLeft: '2px', paddingTop: '1.4%', verticalAlign: 'bottom' }}
                    className="education-heart"
                  />
            </div>
              
            <p className="about-about-body content">
            D.J. Sanghvi College of Engineering, Mumbai • B.Tech in Information Technology, 2019-2023 • <b className="bold-content">CGPA: 9.45</b>
            </p>
            <p className="about-about-body content">
            JaiHind College, Churchgate, Mumbai • 2017-2019 •  <b className="bold-content">HSC: 84.46%</b>
            </p >
            <p className="about-about-body content">Greenlawns High School, Breach Candy, Mumbai • 2017 • <b className="bold-content">ICSE: 96.16%</b></p>
          </Col>
          <Col md={6} className="about-about-description" >
          <hr></hr>
          <div className="title">
          <h1 className="detail-header">
              SKILLS AND INTERESTS
              <img className="skills-heart heart"
                    src={period}
                    alt="period"
                    style={{marginLeft: '3px', paddingTop:'2.5%' }}
                    
                  />
            </h1>
            
            </div>
            <p className="about-about-body content">
            <b className="bold-content">Technical Strengths: </b>Figma, PhotoShop, Premiere Pro, GitHub/Gitlab, SQL, HTML/CSS, JavaScript, ReactJS, Python, Java 
            </p>
            <p className="about-about-body content">
            <b className="bold-content">Professional Skills: </b>Time Management, Teamwork, Creativity, Decision making, Agile
            </p>
            <p className="about-about-body content">
            <b className="bold-content">Interests: </b>Dancing, Listening to Music, Gaming, Painting
            </p>
          </Col>
        </Row>

        
        {/* <Row>
          <Col md={12} className="about-about-description">
            <hr></hr>
            <div style={{display:'flex'}}>
          <h1 style={{ fontSize: "2.4em", fontFamily: "Changa"}}>MEET MY TEAM</h1>
          <img
                    src={period}
                    alt="period"
                    style={{marginLeft: '2px', paddingTop: '1%', verticalAlign: 'bottom' }}
                  />
          </div>
            <Row>
              <Col>hi</Col>
              <Col>hello</Col>
              <Col>hey</Col>
            </Row>
          </Col>
        </Row> */}


      </Container>
    </Container>
  );
}
export default About2;
